'use client';
import Script from 'next/script';
import { WidgetAutonativeDetail } from './autonative-detail';
import { WidgetAutonativeIndex } from './autonative-index';
import mappings from './mappings.json';

declare global {
  interface Window {
    autoNative?: unknown;
    contentGardenContentDelivery?: {
      deliverArticle: () => void;
    };
  }
}

export interface WidgetAutonativeDefaultProps {
  readonly model: {
    readonly fields: {
      readonly type: 'detail' | 'index';
    };
  };
}

export const WidgetAutonativeDefault = ({ context }: { context: WidgetAutonativeDefaultProps }) => {
  const nativeType = context.model.fields.type;

  return (
    <>
      <script
        type="text/javascript"
        id="autonative-mapping"
        dangerouslySetInnerHTML={{ __html: `window.autoNative=${JSON.stringify({ mapping: mappings[nativeType] })}` }}
      />
      <Script id="selfIframeHeight" src="https://static.emsservice.de/responsive/setIframeHeightParent.min.js" async />
      <Script
        id="cdn-cg-js-delivery"
        src="//cdn.content-garden.com/base.min.js"
        onReady={() => {
          window.contentGardenContentDelivery?.deliverArticle();
        }}
      />
      {nativeType === 'index' ? <WidgetAutonativeIndex /> : <WidgetAutonativeDetail />}
    </>
  );
};
